import React from "react";

export default function RibbonSVG({ className }: { className?: string }) {
  return (
    <svg
      width="211"
      height="35"
      viewBox="0 0 211 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.52471 11.0206C7.27935 7.90719 9.57225 4.52051 12.9255 4.52051L31.4009 4.52051C34.0186 4.52051 36.1407 6.64257 36.1407 9.26027V29.9967C36.1407 32.6144 34.0186 34.7365 31.4009 34.7365H12.9255C9.57225 34.7365 7.27936 31.3498 8.52471 28.2364L11.9679 19.6285L8.52471 11.0206Z"
        fill="url(#paint0_linear_657_2059)"
      />
      <mask
        id="mask0_657_2059"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="4"
        width="29"
        height="31"
      >
        <path
          d="M8.52471 11.0206C7.27935 7.90719 9.57225 4.52051 12.9255 4.52051L31.4009 4.52051C34.0186 4.52051 36.1407 6.64257 36.1407 9.26027V29.9967C36.1407 32.6144 34.0186 34.7365 31.4009 34.7365H12.9255C9.57225 34.7365 7.27936 31.3498 8.52471 28.2364L11.2638 21.3888C11.7158 20.2588 11.7158 18.9982 11.2638 17.8682L8.52471 11.0206Z"
          fill="url(#paint1_linear_657_2059)"
        />
      </mask>
      <g mask="url(#mask0_657_2059)">
        <path d="M36.1407 21.7021H24.2913L30.216 28.2193L36.1407 34.7365V21.7021Z" fill="black" fillOpacity="0.4" />
      </g>
      <path
        d="M201.791 11.0206C203.036 7.90719 200.743 4.52051 197.39 4.52051L178.915 4.52051C176.297 4.52051 174.175 6.64257 174.175 9.26027V29.9967C174.175 32.6144 176.297 34.7365 178.915 34.7365H197.39C200.743 34.7365 203.036 31.3498 201.791 28.2364L198.348 19.6285L201.791 11.0206Z"
        fill="url(#paint2_linear_657_2059)"
      />
      <mask
        id="mask1_657_2059"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="174"
        y="4"
        width="29"
        height="31"
      >
        <path
          d="M201.791 11.0206C203.036 7.90719 200.743 4.52051 197.39 4.52051L178.915 4.52051C176.297 4.52051 174.175 6.64257 174.175 9.26027V29.9967C174.175 32.6144 176.297 34.7365 178.915 34.7365H197.39C200.743 34.7365 203.036 31.3498 201.791 28.2364L199.052 21.3888C198.6 20.2588 198.6 18.9982 199.052 17.8682L201.791 11.0206Z"
          fill="url(#paint3_linear_657_2059)"
        />
      </mask>
      <g mask="url(#mask1_657_2059)">
        <path d="M174.175 21.7021H186.024L180.1 28.2193L174.175 34.7365V21.7021Z" fill="black" fillOpacity="0.4" />
      </g>
      <rect x="24.2913" width="161.733" height="25.8494" rx="4.73976" fill="url(#paint4_linear_657_2059)" />
      <defs>
        <linearGradient
          id="paint0_linear_657_2059"
          x1="21.0327"
          y1="4.52051"
          x2="21.0327"
          y2="34.7365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F6BFF" />
          <stop offset="1" stopColor="#1A51AA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_657_2059"
          x1="21.0327"
          y1="4.52051"
          x2="21.0327"
          y2="34.7365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0055" />
          <stop offset="1" stopColor="#C70042" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_657_2059"
          x1="189.283"
          y1="4.52051"
          x2="189.283"
          y2="34.7365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F6BFF" />
          <stop offset="1" stopColor="#1A51AA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_657_2059"
          x1="189.283"
          y1="4.52051"
          x2="189.283"
          y2="34.7365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0055" />
          <stop offset="1" stopColor="#C70042" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_657_2059"
          x1="105.158"
          y1="0"
          x2="105.158"
          y2="25.8494"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F6BFF" />
          <stop offset="1" stopColor="#1A51AA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
